export default __webpack_public_path__ + "static/media/simonSound3.3d5f9156.mp3";